(() => {
  function init(root) {
    root.querySelectorAll('[data-oralie-footer-reveal]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const image = section.querySelector('[data-motion-src]');
      if (!image || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const start = () => {
        image.onload = () => section.classList.add('is-running');
        image.src = image.dataset.motionSrc;
      };
      if (!('IntersectionObserver' in window)) { start(); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.intersectionRatio >= .12)) {
          start();
          observer.disconnect();
        }
      }, { threshold: [.12] });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
